import { openingDetail } from "./room"

export type subscription = {
    _id: string;
    subscriptionName: string;
    subscriptionType: string;
    accessToActivities: boolean;
    notes: string;
    accessToBuy: number;
    monthToBuy: number;
    expiresOn?: Date;
    subscriptionRules: subscriptionRules;

    firebaseUri?: string;
    medicalExaminationDocumentId?: string;
}

export const SUBSCRIPTIONTYPES = {
    // NONE: { code: '', title: '' },
    MENSILE: { code: "MENSILE", title: 'Abbonamento' },
    ACCESSI: { code: "ACCESSI", title: 'Accessi' },
    CORSI: { code: "CORSI", title: 'Corsi' },
};

export const emptySubscription = (): subscription => ({
    _id: '',
    subscriptionName: '',
    subscriptionType: '',
    accessToActivities: true,
    notes: '',
    firebaseUri: undefined,
    accessToBuy: 0,
    monthToBuy: 0,
    subscriptionRules: emptySubscriptionRules(),
});

export type subscriptionRules = {
    monday: openingDetail;
    tuesday: openingDetail;
    wednesday: openingDetail;
    thursday: openingDetail;
    friday: openingDetail;
    saturday: openingDetail;
    sunday: openingDetail;
}

const emptySubscriptionRules = (): subscriptionRules => ({
    monday: emptyOpeningDetail(),
    tuesday: emptyOpeningDetail(),
    wednesday: emptyOpeningDetail(),
    thursday: emptyOpeningDetail(),
    friday: emptyOpeningDetail(),
    saturday: emptyOpeningDetail(),
    sunday: emptyOpeningDetail(),
});

const emptyOpeningDetail = (): openingDetail => ({
    openingTime: { hours: 8, minutes: 0 },
    closingTime: { hours: 20, minutes: 0 },
    duration: 0,
});

export type userSubscription = {
    _id: string;
    subscription?: subscription;
    validFrom?: Date;
    notes: string;
    suspendedOn?: Date;
    registeredAccess: number;
    daysExtra: number;
    accessExtra: number;
    expiresOn: Date;
}

export type day = {
    code: number, name: string, value: string,
}
export const days: Array<day> = [{ code: 1, name: 'Lunedì', value: 'monday' },
{ code: 2, name: 'Martedì', value: 'tuesday' },
{ code: 3, name: 'Mercoledì', value: 'wednesday' },
{ code: 4, name: 'Giovedì', value: 'thursday' },
{ code: 5, name: 'Venerdì', value: 'friday' },
{ code: 6, name: 'Sabato', value: 'saturday' },
{ code: 0, name: 'Domenica', value: 'sunday' }];
